import { ChainSettingsState } from './chain-settings-state';

export class SettingsState {
  language: string | undefined;
  settingsInfoAccepted: boolean | undefined;
  chainSettingsStates: ChainSettingsState[];
}
